/* BSS Custom - TD: an dong "Inkl. 19% Mwst" CHI khi (1) customer tag B2B
 * VA (2) TD rule da thuc su ap dung cho SAN PHAM DANG XEM (bssB2bShowPriceKey === 'td').
 * FIX 17/07 (lan 2): script co defer nen co the chay SAU khi app da ban event
 * 'bss_b2b:loadedObserver' xong -> addEventListener({once:true}) mot minh se
 * KHONG BAT DUOC event do nua. Goi ham ngay 1 lan luc script chay + giu them
 * event listener (phong app load tre hon) + poll ngan (phong productStorage
 * chua kip co du lieu luc script chay lan dau, vi la lazy). */
(function () {
  function isB2BCustomer() {
    const tags = window.BSS_B2B?.shopData?.customer?.tags || [];
    return tags.some((t) => String(t).trim().toLowerCase() === 'b2b');
  }

  function findProductInStore(store, productId) {
    if (!store) return null;
    if (typeof store.get === 'function') {
      const direct = store.get(productId) || store.get(String(productId)) || store.get(Number(productId));
      if (direct) return direct;
    }
    let found = null;
    if (typeof store.forEach === 'function') {
      store.forEach((p) => {
        if (p && String(p.id) === String(productId)) found = p;
      });
    }
    return found;
  }

  function isTDAppliedFor(productId) {
    if (!productId) return false;
    const store = window.BSS_B2B?.storage?.productStorage?.store;
    const product = findProductInStore(store, productId);
    return product?.bssB2bShowPriceKey === 'td';
  }

  function getProductId(form) {
    const priceEl = form.querySelector('[bss-b2b-product-id]');
    return priceEl?.getAttribute('bss-b2b-product-id') || null;
  }

  function updateVatLabelScope() {
    document.querySelectorAll('[bss-b2b-product-form-id]').forEach((form) => {
      const productId = getProductId(form);
      const shouldHide = isB2BCustomer() && isTDAppliedFor(productId);
      form.classList.toggle('bss-td-hide-vat-label', shouldHide);
    });
  }

  // (1) Chay ngay - phong truong hop event 'bss_b2b:loadedObserver' da ban truoc do.
  updateVatLabelScope();

  // (2) Van giu listener - phong truong hop app load TRE hon script nay.
  window.addEventListener('bss_b2b:loadedObserver', updateVatLabelScope, { once: true });

  // (3) Poll ngan (toi da ~4.5s) - phong productStorage chua kip co du lieu
  // luc (1)/(2) chay. Idempotent (classList.toggle), an toan khi goi lap lai.
  let retries = 0;
  const poll = setInterval(() => {
    updateVatLabelScope();
    retries += 1;
    if (retries >= 15) clearInterval(poll);
  }, 300);

  // Doi variant tren PDP/quickview -> chay lai.
  document.addEventListener('change', (e) => {
    if (e.target.closest('[bss-b2b-product-form-id]')) {
      setTimeout(updateVatLabelScope, 300);
    }
  });
})();